import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { LanguageService } from '../../core/language/language.service';
import { UploadImageModel } from '../../core/models/complaint/upload-image.model';
import { ComplaintsService } from '../complaints.service';
import { ToastService } from '../../core/toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Images } from '../../core/models/complaint/images';

@Component({
    selector: 'app-upload-images',
    templateUrl: './upload-images.component.html'
})
export class UploadImagesComponent implements OnInit {
    public pathname: string;
    public selectedFiles: File[] = [];
    public uploadedImages: UploadImageModel[] = [];
    public complaintID: number;
    public imagesFromDb: Images[] = [];

    @ViewChild('image') private image: ElementRef;

    constructor(private _renderer: Renderer2,
        private _languageService: LanguageService,
        private _complaintsService: ComplaintsService,
        private _toastService: ToastService,
        private _route: ActivatedRoute,
        private _router: Router) {
    }

    ngOnInit() {
        this.pathname = location.pathname;
        this._route.params.subscribe(params => {
            let id = +params['complaintId'];
            if (!isNaN(id) && id > 0) {
                this.complaintID = id;
                this._complaintsService.getImagesByComplaintID(this.complaintID).subscribe(result => {
                    this.imagesFromDb = result;
                });
            }
        });
    }

    onSelectedFile(event) {
        if (event.target.files.length > 0) {
            const complaintImage = event.target.files[0];
            this.selectedFiles.push(<File>complaintImage);
            let reader = new FileReader();
            this.readFile(complaintImage, reader, (result: any) => {
                const li: HTMLLIElement = this._renderer.createElement('li');
                const img: HTMLImageElement = this._renderer.createElement('img');
                img.src = result;
                this._renderer.addClass(img, 'complaint-image');

                const a: HTMLAnchorElement = this._renderer.createElement('a');
                a.innerText = this._languageService.instant('Obrisi');
                this._renderer.addClass(a, 'delete-btn');
                //a.addEventListener('click', this.d)

                this._renderer.appendChild(this.image.nativeElement, li);
                this._renderer.appendChild(li, img);
                this._renderer.appendChild(li, a);

                const uploadedImageModel = new UploadImageModel();
                uploadedImageModel.complaintId = this.complaintID;

                const formData = new FormData();
                formData.append('file', complaintImage);
                formData.append('data', JSON.stringify(uploadedImageModel));
                //this._complaintsService.uploadImage(formData).subscribe(result => {
                //    this._complaintsService.getImagesByComplaintID(this.complaintID).subscribe(result => {
                //        this._renderer.removeChild(this.image.nativeElement, li);
                //        this.imagesFromDb = result;
                //    });
                //    this._toastService.activate(this._languageService.instant('uspjesno_snimanje_slike'));
                //});
            });
        }
    }

    readFile(file: File, reader: any, callback: any) {
        reader.onload = () => {
            callback(reader.result);
        }
        reader.readAsDataURL(file);
    }

    deleteFile(index, a) {
    }

    deleteImage(item, i) {
        this.imagesFromDb.splice(i, 1);
        this._complaintsService.deleteComplaintImage(item.imagesId).subscribe(result => {
            let msg = "uspjesno_obrisan_fajl";
            msg = this._languageService.translate(msg);
            this._toastService.activate(msg, "alert-successToast");
        });
    }

    finishReporting() {
        this._toastService.activate(this._languageService.instant('uspjesna_prijava_problema'));
        this._router.navigate(['/complaints/all-complaints']);
    }
}
